import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { IdentityServiceBase } from '@seahorse/auth';
import { LayoutService, SeahorseMenuItem } from '@seahorse/layout';
import { AccountPanelComponent } from '../account-panel/account-panel.component';
import { AppRailComponent } from '../app-rail/app-rail.component';
import { accountInitials } from '../models/account-initials';

/**
 * The SHIPM8 "next" app shell (design handoff, "Step 3, streamlined: the
 * app shell"): a 48px navy top bar and a white icon rail, replacing an
 * app's existing header + sidebar. One generic shell driven by the app's
 * existing `SeahorseMenuItem[]` menu configuration (`@seahorse/layout`),
 * so it works unchanged for super-user's fixed menu and the customer app's
 * dynamic one.
 */
@Component({
  selector: 'sh-app-shell',
  templateUrl: './app-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AppRailComponent, AccountPanelComponent],
})
export class AppShellComponent {
  menu = input.required<SeahorseMenuItem[]>();
  // Already translated (e.g. `routerUtil.currentModuleName | translate` at
  // the call site) -- the shell doesn't run it through the translate pipe
  // itself, so a plain string (like the /ui-kit developer page's title)
  // also works.
  pageTitle = input.required<string>();
  logoUrl = input<string | undefined>(undefined);
  // Absent hides "My profile" in the account panel.
  profileRoute = input<string | unknown[] | undefined>(undefined);
  loginRoute = input<unknown[]>(['/account/login']);
  /** Shows the opt-in "new look" switch in the account panel. */
  showThemeToggle = input(false);

  protected readonly layoutService = inject(LayoutService);
  protected readonly identityService = inject(IdentityServiceBase);

  protected initials(): string {
    return accountInitials(
      this.identityService.identity?.givenName,
      this.identityService.identity?.surname
    );
  }
}
